import React, { useRef, useEffect } from "react";
import ChatMessages from "./ChatMessages";
import ChatInput from "./ChatInput";
import ConsultationForm from "./ConsultationForm";
import Loader from "../Loader";
import card3 from "../../Assets/Images/AIImg.png";
import loaderImg from '../../Assets/Images/Caduceus 512x512.gif';

function ChatContainer({
    consultation,
    chatMessages,
    isCompleted,
    message,
    setMessage,
    sendMessage,
    handleMicToggle,
    isListening,
    isResponsePending,
    isAITyping,
    isLoadingChat,
    onPdfClick,
    register,
    errors,
    onFormSubmit,
    isLoading,
    profile,
    onTypingComplete,
    inputRef,
    micSupported,
    handleDownload,
    handleAddNewConsultation,
    handleEmailToMe,
    consultationSections,
    isLoadingSummary,
    isSmallScreen,
}) {
    const messagesEndRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [chatMessages, isResponsePending, consultation]);

    if (isLoadingSummary) {
        return <div className={`d-flex justify-content-center align-items-center ${isSmallScreen ? 'w-100' : 'w-50'}`}>
            <img src={loaderImg} alt="Loading..." width={'200px'} height={'200px'} />
        </div>
    }
    return (
        <div className="ai_chat_box_right">
            <div className="chat-main">
                <div className="all-chat-main" role="log" aria-live="polite">
                    <div className="day-chat">
                        <p>Today</p>
                    </div>

                    <div className="d-flex flex-column chat_box">
                        {!consultation &&
                            <ConsultationForm
                                register={register}
                                errors={errors}
                                onSubmit={onFormSubmit}
                                consultation={consultation}
                                isLoading={isLoading}
                            />
                        }

                        {consultation && !isLoadingChat && !isCompleted && (
                            <div className="chat_inn_box">
                                <div className="img-chat-date d-flex">
                                    <div className="profile-chat-img">
                                        <img src={card3} alt="AI Avatar" />
                                    </div>
                                    <div className="chat_box_outer">
                                        <div className="chat-box mt-3">
                                            <p className="chat_text second_user_txt">
                                                Ok. Let's jump right in. How can I help you?
                                            </p>
                                            <span className="cs_chat_time second">
                                                {new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {consultation &&
                            (<>
                                {isLoadingChat && <Loader isLoading={true} />}
                                {!isCompleted && <ChatMessages
                                    chatMessages={chatMessages}
                                    isCompleted={isCompleted}
                                    profile={profile}
                                    onTypingComplete={onTypingComplete}
                                />}

                                {isCompleted && consultationSections && (
                                    <div className="chat_inn_box mt-4">
                                        <div className="inner_chat_content_box p-5" style={{ background: '#f8f9fa', borderRadius: '12px' }}>
                                            {consultationSections.map((section, index) => (
                                                <div key={index} className="cnt_wrp mb-3">
                                                    <h6 className="chat_in_heading">{index + 1}. {section.question}:</h6>
                                                    <p className="chat_text mb-5">{section.answer}</p>
                                                </div>
                                            ))}
                                            <div className="comm-pair-btns d-flex align-items-center gap-3 mt-4">
                                                <button onClick={handleDownload} className="main-btn comm_icon_btn edit_profile_btn">
                                                    Download
                                                </button>
                                                <button onClick={handleAddNewConsultation} className="main-btn comm_icon_btn edit_profile_btn">
                                                    New Consultation
                                                </button>
                                                <button onClick={handleEmailToMe} className="main-outline-btn" style={{ borderColor: "#00A1FB", color: "#00A1FB" }}>
                                                    Email to me
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div ref={messagesEndRef} />
                            </>)
                        }
                    </div>
                </div>

                {consultation && !isCompleted && (
                    <ChatInput
                        message={message}
                        setMessage={setMessage}
                        sendMessage={sendMessage}
                        handleMicToggle={handleMicToggle}
                        isListening={isListening}
                        isResponsePending={isResponsePending}
                        isAITyping={isAITyping}
                        onPdfClick={onPdfClick}
                        inputRef={inputRef}
                        micSupported={micSupported}
                    />
                )}
            </div>
        </div>
    );
}

export default ChatContainer;